export default /^inset-/i;
